import React from 'react'
import GoalDetails from '../../../components/goals/details/GoalDetails'
const GoalDetailsWrapper = (props) => {
  return <GoalDetails {...props}  />
}
export default GoalDetailsWrapper